// Translated fallback when AI starter generation is unavailable. Values are
// i18n keys under aiAssistant.suggestions, chosen by the current page.
export function assistantSuggestions(pathname: string): string[] {
  if (/^\/(project|library)\/[^/]+\/ai-studio\/?$/.test(pathname)) {
    // Requests the editor can perform directly in AI Studio.
    return ['studioFunny', 'studioCutPauses', 'studioLayout', 'studioBroll', 'studioHormozi'];
  }
  if (/^\/(project|library)\/[^/]+\/clips\/?$/.test(pathname)) {
    return ['bestClips', 'renderBest', 'captionIdeas'];
  }
  if (/^\/(project|library)\/[^/]+\/edit\/?$/.test(pathname)) {
    return ['renderThisProject', 'subtitleStyleHelp', 'editorTour'];
  }
  if (/^\/community-library\/?$/.test(pathname)) return ['trendingNow', 'remixIdea', 'makeClips'];
  if (/^\/(earn|campaigns)(\/|$)/.test(pathname)) return ['bestCampaign', 'howEarn', 'myEarnings'];
  if (/^\/analytics\/?$/.test(pathname)) return ['analyticsSummary', 'bestPosts', 'myUsage'];
  return ['makeClips', 'latestProjects', 'myUsage'];
}
